module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "decimal-field",
    class: {
      'single-line': _vm.singleLine
    }
  }, [_vm._v("\n  " + _vm._s(_vm.formattedValue) + "\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-24a8105a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/table-field/FieldDecimal.vue
// module id = 666
// module chunks = 0